"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.736 5.003C6.736 3.908 7.612 3 8.718 3h2.564c1.105 0 1.982.908 1.982 2.003V7.61q0 .043-.002.085c-.003 2.239-.108 4.516-.853 6.248-.385.896-.954 1.676-1.789 2.225-.834.55-1.877.832-3.147.832a.7.7 0 1 1 0-1.4c1.06 0 1.82-.234 2.377-.6.557-.367.97-.905 1.273-1.61.443-1.03.63-2.351.7-3.852q-.258.076-.541.076H8.718c-1.106 0-1.982-.908-1.982-2.004z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ThousandsIcon20.js.map